<!-- eslint-disable quotes -->
<!-- eslint-disable quotes -->
<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="800px">
      <v-card>
        <v-toolbar elevation="0" color="background">
          <v-toolbar-title
            class="pl-4 text-h6 font-weight-medium"
            :class="{
              'brand--text text--darken-2': !$vuetify.theme.dark,
            }"
          >
            Quiz
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="handleClose">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="px-2 py-0 pr-4">
          <div class="scroll-container ml-3">
            <draggable
              v-model="questions"
              group="question"
              @start="drag = true"
              @end="drag = false"
            >
              <v-col
                cols="12"
                v-for="(question, index) in questions"
                :key="index"
                class="pa-1"
              >
                <v-row no-gutters>
                  <v-card class="mt-2 ml-2 mr-2" outlined width="100%">
                    <v-col
                      cols="12"
                      style="cursor: pointer"
                      @click="handleExpandQuestion(index)"
                    >
                      <v-row
                        class="fill-height"
                        no-gutters
                        align="center"
                        justify="space-between"
                      >
                        <span
                          class="text-truncate"
                          style="max-width: calc(95% - 50px)"
                          :title="question.enunciate"
                        >
                          <v-icon color="contrast">mdi-drag</v-icon>
                          {{ question.enunciate }}</span
                        >
                        <v-icon
                          class="pr-2"
                          @click.stop="removeQuestion(index)"
                        >
                          mdi-delete
                        </v-icon>
                      </v-row>
                    </v-col>
                    <v-col
                      class="pa-0"
                      cols="12"
                      v-if="index === expandedQuestionIndex"
                    >
                      <v-divider />
                    </v-col>
                    <v-col
                      cols="10"
                      v-if="index === expandedQuestionIndex"
                      class="mt-1 mx-auto"
                    >
                      <v-textarea-legacy
                        v-model="question.enunciate"
                        outlined
                        label="Enunciado"
                        hide-details
                        rows="2"
                        row-height="20"
                      ></v-textarea-legacy>
                      <v-col cols="12" class="pa-0 mt-5">
                        <v-row
                          v-for="(option, index) in question.options"
                          :key="index"
                          no-gutters
                          class="mt-2"
                        >
                          <v-col class="shrink">
                            <v-radio-group
                              v-model="questionCorrectIndex"
                              :key="question.enunciate"
                              hide-details
                              class="mt-0"
                            >
                              <v-radio class="mt-1" :value="index"></v-radio>
                            </v-radio-group>
                          </v-col>
                          <v-col>
                            <v-text-field
                              v-model="option.text"
                              outlined
                              hide-details
                              label="Opção"
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col
                            class="pl-2 shrink d-flex flex-row align-center justify-center"
                          >
                            <v-icon
                              :disabled="question.options.length < 2"
                              size="20"
                              style="cursor: pointer"
                              @click="removeOption(index)"
                            >
                              mdi-close-circle-outline
                            </v-icon>
                          </v-col>
                        </v-row>
                        <v-btn
                          :disabled="question.options.length > 4"
                          class="mt-5"
                          color="primary"
                          outlined
                          @click="addOption"
                          >{{ $t('message.ai.quiz.addOption') }}</v-btn
                        >
                      </v-col>
                    </v-col>
                  </v-card>
                </v-row>
              </v-col>
            </draggable>
          </div>
        </v-card-text>
        <v-col cols="12" class="pa-0 pl-8 mt-5 mb-6">
          <v-btn
            color="primary"
            class="elevation-0"
            @click="handleAddQuestion"
            >{{ $t('message.ai.quiz.addQuestion') }}</v-btn
          >
        </v-col>
        <v-col cols="12" class="pa-0">
          <v-divider />
        </v-col>
        <v-card-actions class="px-8 py-6">
          <BaseBtn
            type="secondary"
            class="elevation-0 mr-4 px-4"
            :disabled="checkIfHasChanged"
            @click="handleDiscardChanges"
          >
            {{ $t('message.pages.video.discardChanges') }}
          </BaseBtn>
          <v-spacer></v-spacer>
          <BaseBtn
            :loading="loadings.updatingQuestions"
            class="elevation-0 primary white--text"
            min-width="185px"
            @click="handleSaveQuestion"
          >
            {{ $t('message.pages.video.save') }}
          </BaseBtn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import aiworkflowApi from '@/services/aiworkflowApi'
import _ from 'lodash'
import draggable from 'vuedraggable'
import BaseBtn from '@/components/BaseBtn.vue'

export default {
  name: 'VideoPlayerQuizModal',
  components: {
    draggable,
    BaseBtn,
  },
  data: () => ({
    open: false,
    questions: [],
    initialQuestionsVal: [],
    isEditing: false,
    beingEditedQuestion: {
      enunciate: '',
      options: [{ text: '', corrrect: true }],
    },
    question: { enunciate: '', options: [{ text: '', corrrect: true }] },
    questionCorrectIndex: 0,
    questionIndex: 0,
    loadings: {
      updatingQuestions: false,
    },
    expandedQuestionIndex: -1,
    drag: false,
  }),
  mounted() {
    this.$root.$on('openVideoQuizModal', (data) => {
      this.open = true
      this.questions = _.cloneDeep(data.questions)
      this.initialQuestionsVal = _.cloneDeep(data.questions)
    })
  },
  computed: {
    checkIfHasChanged() {
      return _.isEqual(this.questions, this.initialQuestionsVal)
    },
  },
  watch: {
    questionCorrectIndex() {
      this.questions[this.expandedQuestionIndex].options.forEach((option) => {
        option.correct = false
      })
      this.questions[this.expandedQuestionIndex].options[
        this.questionCorrectIndex ?? 0
      ].correct = true
    },
  },
  beforeDestroy() {},
  methods: {
    handleDiscardChanges() {
      this.questions = _.cloneDeep(this.initialQuestionsVal)
    },
    handleExpandQuestion(index) {
      if (this.expandedQuestionIndex === index) {
        return (this.expandedQuestionIndex = -1)
      } else {
        this.expandedQuestionIndex = index
        this.questionCorrectIndex = this.questions[index].options.findIndex(
          (option) => option.correct
        )
      }
    },
    async updateQuestions(newQuestions) {
      const videoId = this.$route.params.id
      const aiData = {
        video_id: videoId,
        questions: newQuestions,
      }
      try {
        let res = await aiworkflowApi.updateAiWorkFlowData(aiData)
        this.questions = res.data.questions
        this.$root.$emit('quizUpdateQuestions', res.data.questions)
        this.handleClose()
      } catch (e) {
        console.error('e', e)
      }
    },
    async removeQuestion(indexToRemove) {
      const newArray = [
        ...this.questions.slice(0, indexToRemove),
        ...this.questions.slice(indexToRemove + 1),
      ]
      this.questions = newArray
    },
    addOption() {
      if (this.questions[this.expandedQuestionIndex].options.length > 4) return
      this.questions[this.expandedQuestionIndex].options.push({
        text: '',
        correct: false,
      })
    },
    removeOption(optionIndex) {
      if (this.questions[this.expandedQuestionIndex].options.length < 2) return
      if (
        this.questions[this.expandedQuestionIndex].options[optionIndex].correct
      ) {
        this.questionCorrectIndex = 0
      }
      this.questions[this.expandedQuestionIndex].options.splice(optionIndex, 1)
    },
    handleQuestion(question, index) {
      this.isUpdateQuestion = false
      this.questions[this.expandedQuestionIndex] = {
        enunciate: '',
        options: [{ text: '', corrrect: true }],
      }
      if (question?.enunciate) {
        this.initialEditingQuestionValue = question
        this.questions[this.expandedQuestionIndex] = question
        this.questionIndex = index
        this.isUpdateQuestion = true
      }
      this.isEditing = true
    },
    handleAddQuestion() {
      this.questions.push({
        enunciate: '',
        options: [{ text: '', correct: true }],
      })
    },
    async handleSaveQuestion() {
      if (
        this.questionIndex >= 0 &&
        this.questionIndex < this.questions.length &&
        this.isUpdateQuestion
      ) {
        this.questions[this.questionIndex] = this.beingEditedQuestion
      }
      let newQuestions = this.questions.map((question) => question)
      this.loadings.updatingQuestions = true
      await this.updateQuestions(newQuestions)
      this.$root.$emit('refreshVideoInfo')
      this.isEditing = false
      this.loadings.updatingQuestions = false
    },
    handleClose() {
      this.$root.$emit('renameModalClosed')
      this.open = null
    },
  },
}
</script>

<style>
.cardTitle {
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
}
.scroll-container {
  max-height: 400px;
  overflow-y: auto;
}
</style>
